import { useMutation } from "@tanstack/react-query";
import { fetcher } from "../../../utils/Axios";
import { RESET_PASSWORD_REQUEST } from "../types/RequestTypes";
import { showToast } from "../../../utils/ToastEmitter";

async function resetPassword(req: RESET_PASSWORD_REQUEST) {
  return fetcher({
    url: "users/update/password",
    method: "PATCH",
    data: req,
    authRequired: false,
    skipAuthRefresh: true,
  });
}

export default function useResetPasswordMutation(cb?: () => void) {
  return useMutation({
    mutationFn: resetPassword,
    onSuccess: () => {
      cb?.();
      showToast("Password_updated_successfully", "success");
    },
    onError: () => {
      cb?.();
      showToast("Password_was_not_updated", "error");
    },
  });
}
